const vars = {
  colorHeaderBg: `#F2F2F2`,
  colorText: `#0C121C`,
  containerWidth: `1336px`,
  transitionFast: `.15s`,
  transitionMed: `.45s`,
}

module.exports = vars



// WEBPACK FOOTER //
// ./src/utils/variables.js